import { render, staticRenderFns } from "./LogoCategories.vue?vue&type=template&id=1a2bb8e6&scoped=true&"
import script from "./LogoCategories.vue?vue&type=script&lang=js&"
export * from "./LogoCategories.vue?vue&type=script&lang=js&"
import style0 from "./LogoCategories.vue?vue&type=style&index=0&id=1a2bb8e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2bb8e6",
  null
  
)

export default component.exports